import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";

import { TableSpinner } from "../../components";
import { useGetCourseSelectListQuery } from "../../store/api/courseApi";
import {
  buildSubjectsSearch,
  getCourseIdBySlug,
} from "../../utils/subjectsNavigation";

export const SubjectsLegacyRedirect = () => {
  const history = useHistory();
  const { course, gradeId } = useParams<{ course: string; gradeId?: string }>();
  const { data: courses } = useGetCourseSelectListQuery();

  useEffect(() => {
    if (!courses?.length || !course) return;

    const courseId = getCourseIdBySlug(courses, course);
    const search = buildSubjectsSearch({
      courseId,
      gradeId: gradeId || "",
    });
    history.replace(`/subjects${search}`);
  }, [courses, course, gradeId, history]);

  return <TableSpinner />;
};
